import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "mapAttr" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "relative w-full z-20"
}
const _hoisted_3 = {
  class: "border absolute w-full bg-white",
  "data-dusk": "address-results"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = {
  key: 1,
  class: "relative w-full z-20"
}
const _hoisted_7 = { class: "border absolute w-full bg-white p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTextInput = _resolveComponent("BaseTextInput")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _withDirectives(_createVNode(_component_BaseTextInput, {
      modelValue: _ctx.addressText,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addressText) = $event)),
        _ctx.handleChangedTextInput
      ],
      label: _ctx.label,
      "is-optional": _ctx.isOptional,
      clear: "",
      "data-dusk": "address-input",
      placeholder: _ctx.placeholder,
      error: _ctx.error
    }, null, 8, ["modelValue", "label", "is-optional", "placeholder", "error", "onUpdate:modelValue"]), [
      [_directive_click_away, _ctx.clickAway]
    ]),
    (!_ctx.loading && _ctx.autocompleteResults.length)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autocompleteResults, (result, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "cursor-pointer hover:bg-gray-100",
                "data-dusk": "address-result",
                onClick: ($event: any) => (_ctx.getPlaceDetails(result.value))
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(result.label), 1)
              ], 8, _hoisted_4))
            }), 128))
          ])
        ])), [
          [_directive_click_away, _ctx.clickAway]
        ])
      : (_ctx.loading)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('platform.common.loading')) + "... ", 1)
          ])), [
            [_directive_click_away, _ctx.clickAway]
          ])
        : _createCommentVNode("", true)
  ]))
}